var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDmqaNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 146,
    viewBox: "0 0 390 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ovoarmn2za)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h390v146H0V0z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 136,
    width: 260,
    height: 16,
    rx: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 112,
    width: 260,
    height: 16,
    rx: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 88,
    width: 260,
    height: 16,
    rx: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 64,
    width: 196,
    height: 16,
    rx: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 40,
    width: 196,
    height: 16,
    rx: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 150,
    height: 27,
    rx: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5h390v202H0V-5z",
    fill: "url(#51awm4sawb)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "51awm4sawb",
    x1: 195,
    y1: -98.053,
    x2: 195,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ovoarmn2za"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h390v146H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDmqaNodata);
export default __webpack_public_path__ + "static/media/img_dmqa_nodata.0022be2d70d47b6f047254cdeef0205c.svg";
export { ForwardRef as ReactComponent };